import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { NextSteps } from './components/NextSteps';
import { Support } from './components/Support';
import { Footer } from './components/Footer';
import { Confetti } from './components/Confetti';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-aurora-pink selection:text-white" data-id="element-0">
      <Confetti data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <NextSteps data-id="element-5" />
        <Support data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}